import {useContext} from 'react';

import {ReactSubscriptionsContext, SubscriptionPlanProductType} from '@udemy/subscription-graphql';

const GWG_PLAN_TYPES = [
    SubscriptionPlanProductType.GrowWithGoogle,
    SubscriptionPlanProductType.ConsumersubscriptionPlusGrowWithGoogle,
] as const;

export const useIsGwgAvailable = (): boolean => {
    const subscriptionPlans = useContext(ReactSubscriptionsContext);

    return GWG_PLAN_TYPES.some((key) => {
        const plan = subscriptionPlans[key];
        return !!plan && !plan.isLoading && ('id' in plan || plan.isSubscriberToSpecificPlan);
    });
};
